const SoonItem = () => {
  return (
    <div className="absolute right-[0.428vw] z-20 top-1/2 -translate-y-1/2 max-lg:right-[1.6vw] lg:opacity-0 lg:group-hover:opacity-100 transition-opacity duration-300">
      <div className="bg-[#E9EBF3] z-10  flex items-center justify-center w-fit soon-border custom-shadow  h-[2vw] px-[0.857vw]  max-lg:px-[3.2vw] max-lg:h-[7.46vw]">
        <p className="font-luxora-regular leading-[1.1] text-[1vw] max-lg:text-[3.73vw] text-black">
          Soon
        </p>
      </div>
    </div>
  );
};

export default SoonItem;
